module.exports = {"title":"Förening"};